import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Icon, Step } from 'semantic-ui-react'

import { Cont } from './styled'
import Approvers from './Approvers'

const DocumentStep = (props) => {
  let {
    // props
    documentDetail: { status },
    approvers = [],
    documentDetail,
    showGOA = true
  } = props
  const getStepActivity = () => {
    if ([0, 4, 6].indexOf(status) >= 0) return null
    if (status === 5) return <Step.Description>{documentDetail.statusActivity}</Step.Description>
    else if (status === 500) return <Step.Description>{documentDetail.statusActivity}</Step.Description>
    else if (status === 7) return <Step.Description>{documentDetail.statusActivity}</Step.Description>
    else if (status === 2) return <Step.Description>{documentDetail.statusActivity}</Step.Description>
    else if (documentDetail && documentDetail.documentNumber && documentDetail.documentNumber.includes('LG')) return <Step.Description>{documentDetail.statusActivity}</Step.Description>

    let step = approvers.find(x => x.isCurrentStep)
    return step ?
      <Step.Description>
        {step.stepName === 'GOA' ? `${step.stepName} Approval` : step.stepName}
      </Step.Description> : null
  }

  const checkNonActive = () => {
    if (documentDetail && documentDetail.documentNumber && documentDetail.documentNumber.includes('LG')) {
      return documentDetail.status == 8
    } else if (documentDetail && documentDetail.documentNumber && documentDetail.documentNumber.includes('PO')) {
      return documentDetail.status == 7
    }
  }

  return (
    <Cont>
      <Step.Group size='mini'>
        <Step className={`${checkNonActive() ? 'stepWait' : [6, 800].indexOf(status) >= 0 ? 'stepWait' : 'stepComplete'}`}>
          <Icon name='plus circle' />
          <Step.Content>
            <Step.Title>{`${status !== 0 ? 'Created' : 'Create'}`}</Step.Title>
          </Step.Content>
        </Step>
        <Step className={`${checkNonActive() ? 'stepWait' : status == 0 ? 'stepWait' : [4, 900].indexOf(status) >= 0 ? 'stepComplete' : [6, 800].indexOf(status) >= 0 ? 'stepWait' : 'stepInprocess'}`}>
          {showGOA && <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}></div>}
          <Icon name='forward' />
          <Step.Content>
            <Step.Title>In Process</Step.Title>
            {getStepActivity()}
          </Step.Content>
          {showGOA &&
            <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
              <Approvers approvers={approvers} status={status} trigger={<Icon name='sort numeric down' circular inverted link />} />
            </div>}
        </Step>
        <Step className={`${checkNonActive() ? 'stepWait' : [4, 900].indexOf(status) >= 0 ? 'stepComplete' : [6, 800].indexOf(status) >= 0 ? 'stepCancelled' : 'stepWait'}`}>
          <Icon name='check circle' />
          <Step.Content>
            <Step.Title>{`${checkNonActive() ? 'Non-Active' : [6, 800].indexOf(status) >= 0 ? 'Cancelled' : [4, 900].indexOf(status) >= 0 ? 'Completed' : 'Complete'}`}</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    </Cont>
  )

}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {
}

DocumentStep.propTypes = {
  documentDetail: PropTypes.object,
  approvers: PropTypes.array,
}

DocumentStep.defaultProps = {
  documentDetail: {},
  approvers: [],
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentStep)
